'use client';

import Image from 'next/image';

import { motion, type Easing } from 'framer-motion';

import { BackgroundParticles } from '../marketing/sections/new-hero/background/background-particles';
import { BackgroundSquares } from '../marketing/sections/new-hero/background/background-squares';

const ease: Easing = [0.16, 1, 0.3, 1];

const AuthBackground = () => {
  return (
    <>
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.5, duration: 3, ease }}
        className="pointer-events-none absolute top-0 z-20 h-full w-full"
      >
        <Image
          src="/images/background-glow.png"
          alt="background glow"
          width={0}
          height={0}
          sizes="100%"
          style={{ width: '100%', height: '100%' }}
          className="max-w-none"
        />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.5, duration: 3, ease }}
        className="pointer-events-none absolute top-[20%] z-0 mx-auto h-full w-full max-w-1440"
      >
        <BackgroundParticles />
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 2, ease }}
        className="absolute top-0 z-10 w-full"
      >
        <BackgroundSquares />
      </motion.div>
    </>
  );
};

export default AuthBackground;
